// Webpack Imports
import * as bootstrap from 'bootstrap';
import megaMenu from './mega-menu';
import menuHandlers from './menu-handlers';
import backToTop from './back-to-top';
import dealerPage from './dealer-page';
import dealerDidCookie from './dealer-did-cookie';
import dealerSlider from './dealer-slider';
import blogPages from './blog-pages';
import reviews from './reviews';
import selectForms from './select2';
import validateZipCode from './validate-zip-code';
import scrollDealerOnLoad from './scroll-dealer-on-load';
import energyCalc from './energy-calculator';
import galleryCarousel from './elementor-gallery-carousel';
import notificationBar from './notification-bar';
import scrollLearningCenterOnLoad from './scroll-learning-center';
import languageActive from './language-active';
import gfHmc from './gfHmc';
// import ownersManualsPopover from './ownersManualsPopover';

(() => {
	menuHandlers(jQuery);
	megaMenu(jQuery);
	backToTop(jQuery);
	dealerPage(jQuery);
	dealerDidCookie(jQuery);
	dealerSlider(jQuery);
	blogPages(jQuery);
	// reviews(jQuery);
	selectForms(jQuery);
	validateZipCode(jQuery);
	scrollDealerOnLoad(jQuery);
	energyCalc(jQuery);
	galleryCarousel(jQuery);
	notificationBar(jQuery);
	scrollLearningCenterOnLoad(jQuery);
	languageActive(jQuery);
	gfHmc(jQuery);
	// ownersManualsPopover(jQuery);
})();

( function () {
	'use strict';
	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
	var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  		return new bootstrap.Tooltip(tooltipTriggerEl)
	});
	$( ".hero-model__content-reviews .bv-star-rating, .hero__reviews .bv-star-rating").css({
		'cursor' : 'pointer',
	});

	window.onload = function WindowLoad(event) {
		let hash_link = window.location.hash;
		if ( $('body').hasClass('single-collections') && (hash_link == '#section--reviews') ) {
			$('.hero__reviews .bv-star-rating').trigger('click');
		}
	}

	// Initialize anchor scroll bv-block-reviews

	const scrollIntoViewWithOffset = (selector, offset) => {
		window.scrollTo({
			behavior: 'smooth',
			top:
			document.querySelector(selector).getBoundingClientRect().top -
			document.body.getBoundingClientRect().top -
			offset,
		})
	}

	$( ".hero-model__reviews-count, .hero-model__content-reviews .bv-star-rating, .hero__reviews .bv-star-rating, .hero__reviews a").on( "click", function(e) {

		var myCollapseEl = document.getElementById('bv-block-reviews');
		var bsCollapse = bootstrap.Collapse.getOrCreateInstance(myCollapseEl);
		bsCollapse.show();
		scrollIntoViewWithOffset('#bv-block-reviews', document.querySelector("header.header").offsetHeight + 10 );
		e.preventDefault();
	});

	$(".elementor-widget-sections-reviews .link-btn a.btn[aria-controls='bv-block-reviews']").on( "click", function(e) {
		var myCollapseEl = document.getElementById('bv-block-reviews');
		var bsCollapse = bootstrap.Collapse.getOrCreateInstance(myCollapseEl);
		bsCollapse.show();
		scrollIntoViewWithOffset('#bv-block-reviews', document.querySelector("header.header").offsetHeight + 150 );
		e.preventDefault();
	});

	// Initialize anchor scroll jump-to

	const anchors = document.querySelectorAll('.dropdown.jump-to .dropdown-item a[href*="#"]');

	if (anchors) {
		anchors.forEach(anchor => {
			const blockID = anchor.getAttribute('href').substr(1);
			const anchorBlock = document.getElementById(blockID);
			const header = document.querySelector("header.header");

			if (anchorBlock) {
				anchor.addEventListener('click', e => {
					e.preventDefault();

					window.scrollTo({
						behavior: 'smooth',
						top: anchorBlock.getBoundingClientRect().top - document.body.getBoundingClientRect().top - header.offsetHeight - 10,
					});
				})
			}
		})
	}

	var async = function(func) {
		return function() {
			var args = arguments;
			setTimeout(function() {
				func.apply(this, args);
			}, 0);
		};
	};

	async(energyCalc().init());
	async(galleryCarousel().init());

	$(".hss-owners-manual-current-collection-downloads a").on("click", function () {
    const destination = $($(this).attr('href')).offset().top - $(".header").height();
		$( 'html, body' ).animate( { scrollTop: destination } );
  });
	
} )();
